class MainProductDetails extends HTMLElement
{
    connectedCallback()
    {
        Array
            .from(this.querySelectorAll(".main-product-details-item"))
            .forEach( (item, index, array) => {
                item.addEventListener('click', () => {
                    console.log(array)
                    array.forEach( _item => _item !== item && _item.classList.remove('active') )

                    item.classList.toggle('active')
                })
            })
    }
}

customElements.define('main-product-details', MainProductDetails)